/* Home page History slider */
$( document ).ready( function() {
  
  $('.history-slider-section .slider-group').on('init afterChange', function(e, slick){
    let currentSlick = $('.slick-current.slick-active', slick.$slideTrack)
    let prevName = currentSlick.prev().find('.item').data('slide-name')
    let nextName = currentSlick.next().find('.item').data('slide-name')
  
    slick.$prevArrow.text(prevName)
    slick.$nextArrow.text(nextName)

  });

  $('.history-slider-section .slider-group').slick({
    dots: true,
    arrows: true,
    infinite: false,
    speed: 800,
    slidesToShow: 1,
    adaptiveHeight: true
  });
  $('.history-slider-section .slider-group').show();
  
});


/* Home page Tech info blocks */
$( document ).ready( function() {
  
  $(document).on('click touchstart', '.tech-details-section .button', function(){
    $('.tech-details-section .button-active').removeClass('button-active');
    $(this).addClass('button-active');
    $('.tech-details-section .item-active').removeClass('item-active');
    var itemActive = $(this).data("item");
    $('.'+itemActive).addClass('item-active');
  });
  
  $(document).on('click touchstart', '.tech-details-section .item', function(){
    $('.tech-details-section .item-active').removeClass('item-active');
    $(this).addClass('item-active');
    $('.tech-details-section .button-active').removeClass('button-active');
    var buttonActive = $(this).data("button");
    $('.'+buttonActive).addClass('button-active');
  });
  
});


/* Home page Reviews slider */
$( document ).ready( function() {
  
  $('.reviews-slider').slick({
    autoplay: true,
    arrows: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    prevArrow: $('.arrow-nav .prev-slide'),
    nextArrow: $('.arrow-nav .next-slide')
  });
  $('.reviews-slider').show();
  
});


/* Home page Manual Insta feed */
$.fn.shuffle = function() {
  var allElems = this.get(),
      getRandom = function(max) {
        return Math.floor(Math.random() * max);
      },
      shuffled = $.map(allElems, function(){
        var random = getRandom(allElems.length),
            randEl = $(allElems[random]).clone(true)[0];
        allElems.splice(random, 1);
        return randEl;
      });
 
  this.each(function(i){
    $(this).replaceWith($(shuffled[i]));
  });
 
  return $(shuffled);
 
};

$( document ).ready( function() {
  
  $('.manual-insta-section .item').shuffle();
  $('.manual-insta-section .wrapper').children('div').not(':first-child').wrapAll('<div class="others-group" />');
  $('.manual-insta-section .wrapper').children('div:first-child').wrapAll('<div class="main-group" />');
  $('.manual-insta-section .main-group').prepend('<div class="title">Follow us on Instagram</div>');
  $('.manual-insta-section .main-group').append('<p><a href="https://www.instagram.com/glisodin_skin/" target="_blank">@glisodin_skin</a></p>');
  
});



/* Product page - Details */
$(document).ready(function(){
  $(".p_details__item-title").on('click touchstart', function(e){
    e.stopPropagation();
    if( !$(this).hasClass('opened') ) {
      $(this).addClass('opened');
      $(this).parent().find($('.p_details__item-txt')).slideDown();
    } else {
      $(this).removeClass('opened');
      $(this).parent().find($('.p_details__item-txt')).slideUp();
    }
    e.preventDefault();
  });
});


/* Product page - Long desc */
$( document ).ready( function() {
  
  $(".p_long_desc__img .toggle").on('click touchstart', function(e){
    e.stopPropagation();
    $('.p_long_desc__txt').slideToggle ('fast');
    $(this).toggleClass( "open" );
    e.preventDefault();
  });
  
});
  

/* Product page - Questions */
$( document ).ready( function() {
  
  $('.p_questions__list .p_questions__item:nth-child(n+4)').wrapAll('<div class="p_questions__more-items" />');
  $(document).on('click touchstart', '.p_questions__list .btn-toggle', function(){
    $('.p_questions__more-items').slideToggle ('fast');
    if( $(this).hasClass('questions-open') ){
      $(this).children().html('See more questions');
    } else {
      $(this).children().html('See less questions');
    };
    $(this).toggleClass('questions-open');
  });
  
});

  
/* Product page - Users */
$( document ).ready( function() {

const swiperCommitments = new Swiper('.p_users__list .swiper-container', {
  slidesPerView: 'auto',
  pagination: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
  
});
  
 
// Megamenu
$(document).ready(function(){
  
  $('.blockmenu-desktop .site-nav__link').hover(function () {
    var itemTarget = $(this).data("meganav-target");
    $('.megamenu__item').css('display','none');
    $('.megamenu__'+itemTarget).css('display','block');
    $(".megamenu").stop().fadeIn("fast");
    $("#PageContainer").addClass('darkened');
    $("#shopify-section-footer").addClass('darkened');
  }, function(){
    $(".megamenu").stop().fadeOut("fast");
    $("#PageContainer").removeClass('darkened');
    $("#shopify-section-footer").removeClass('darkened');
  });
  
  $('.megamenu__item').hover(function () {
    $(".megamenu").stop().fadeIn("fast");
    var itemParent = $(this).data("meganav-parent");
    $('.site-nav__link.menu-'+itemParent).css('opacity','0.75');
    $("#PageContainer").addClass('darkened');
    $("#shopify-section-footer").addClass('darkened');
  }, function(){
    $(".megamenu").stop().fadeOut("fast");
    var itemParent = $(this).data("meganav-parent");
    $('.site-nav__link.menu-'+itemParent).removeAttr('style');
    $("#PageContainer").removeClass('darkened');
    $("#shopify-section-footer").removeClass('darkened');
  });
  
});
  
  
/* Blog articles in category pages */
$( document ).ready( function() {

const swiperBlogFeatCat = new Swiper('.c-articles__list .swiper-container', {
  slidesPerView: 'auto',
  pagination: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
  
});

  
/* About page Commitments slider */
$( document ).ready( function() {

const swiperCommitments = new Swiper('#shopify-section-featured-commitments .swiper-container', {
  slidesPerView: 'auto',
  pagination: false,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});
  
});
  
  
// Mobile menu
var resizeMenuListener = function(){
  var drawerTop = $('.announcement-bar').height()+$('.site-header').height()+2;
  $('#NavDrawer').css('top', drawerTop);
};
resizeMenuListener();
$(window).resize(function(){ resizeMenuListener(); });
  
$(document).ready(function(){
  $('body').off('click touchstart', '.mobile-nav__link').on('click touchstart', '.mobile-nav__link', function(e) {
    if( $(this).hasClass('opened') ) {
      $(this).removeClass('opened');
      $(this).parent().find($('.submenu-mobile')).slideUp();
    } else {
      $(this).addClass('opened');
      $(this).parent().find($('.submenu-mobile')).slideDown();
    }
  });
});
  
  
// Dropdown product attributes
$( document ).ready( function() {
  if( $('div').hasClass('product-single__pricing') ){
    $('.product-form__item select').select2({
      minimumResultsForSearch: Infinity
    });
  }
});
  
  
// Product evolution text blocks
$( document ).ready( function() {
  $('.point i').hover(function () {
    $(this).parent().find($('.txt')).stop().fadeIn("fast");
  }, function(){
    $(this).parent().find($('.txt')).stop().fadeOut("fast");
  });
  
  $(".p_progress__graph .point").on('click touchstart', function(e){
    e.stopPropagation();
    var pointMobileTarget = $(this).data('mobile');
    $('.point-mobile:not(.'+pointMobileTarget+')').css('display','none');
    if($('.'+pointMobileTarget).is(':hidden')){
      $('.'+pointMobileTarget).slideDown();
    } else {
      $('.'+pointMobileTarget).slideUp();
    }
    e.preventDefault();
  });
  $(".point-mobile").on('click touchstart', function(e){
    e.stopPropagation();
    $(this).slideUp();
    e.preventDefault();
  }); 

});
  
  
// Shops list
$( document ).ready( function() {
  
  $(".js-shopslist-open-button").on('click touchstart', function(e){
    e.stopPropagation();
    $('html,body').addClass('js-drawer-open');
    $('html,body').addClass('js-drawer-open-right');
    e.preventDefault();
  });
  
  $('.js-drawer-close').click(function(e) {
    e.stopPropagation(); // prevent bubbling since we don't need other handlers.
    $('html,body').removeClass('js-drawer-open');
    $('html,body').removeClass('js-drawer-open-right');
  }); 
  
  $('#ShopsDrawer').click(function(e){
    e.stopPropagation(); // prevent bubbling to document handler so div stays open when clicked inside, but not on a link
  });
  
  $(document).click(function() {
    $('html,body').removeClass('js-drawer-open');
    $('html,body').removeClass('js-drawer-open-right');
  });

});